import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import styles from './ContentsAndAllergens.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Product } from '@/domain/Product';
import {
  getKnownProductSpecificationByKey,
  type FeatureSpecification
} from '@/domain/Specification';

export type ContentsAndAllergensProps = {
  product: Product;
};

export default function ContentsAndAllergens({
  product
}: ContentsAndAllergensProps) {
  const { t } = useTranslations();
  const ingredients =
    getKnownProductSpecificationByKey<FeatureSpecification[]>(
      product.specifications,
      'ingredients'
    ) ?? [];

  if (!ingredients.length) {
    return null;
  }

  return (
    <section class={styles.container}>
      <details class={styles.details}>
        <summary>
          {t('productList.quickView.contentsAndAllergens.headingText')}
        </summary>
        <div class={styles.content}>
          {ingredients.map((item) => (
            <IngredientsList
              key={`ingredient-${item.order}`}
              ingredient={item}
            />
          ))}
        </div>
      </details>
    </section>
  );
}

function IngredientsList({ ingredient }: { ingredient: FeatureSpecification }) {
  const { title, description } = ingredient;

  if (title === 'title') {
    return (
      <FormattedText className={styles.title} as="h3">
        {description}
      </FormattedText>
    );
  }

  if (title === 'description') {
    return (
      <FormattedText className={styles.description}>
        {description}
      </FormattedText>
    );
  }

  return null;
}
